import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PatientSearchScreen } from '@/modules/consumer/screens/PatientSearchScreen';
import { DoctorProfileScreen } from '@/modules/consumer/screens/DoctorProfileScreen';
import IdentityOnboardingScreen from '@/modules/consumer/screens/IdentityOnboardingScreen';
import { GenerateInviteScreen } from '@/modules/consumer/screens/GenerateInviteScreen';
import { BecomeProfessionalScreen } from '@/modules/professional/screens/BecomeProfessionalScreen';
import { ProfileSettingsScreen } from '@/modules/consumer/screens/ProfileSettingsScreen';
import { BookingScreen } from '@/modules/consumer/screens/BookingScreen';
import { MisCitasScreen } from '@/modules/consumer/screens/MisCitasScreen';

// Tipos exportados para uso en useNavigate / Link desde pantallas hijas
export type ConsumerRoute =
  | '/app/search'
  | '/app/identity'
  | '/app/settings'
  | '/app/admin/invite'
  | '/app/become-pro'
  | '/app/citas'
  | `/app/doctor/${string}`
  | `/app/Booking`;

export function ConsumerNavigator() {
  return (
    <Routes>
      <Route path="search"          element={<PatientSearchScreen />} />
      <Route path="identity"        element={<IdentityOnboardingScreen />} />
      <Route path="admin/invite"    element={<GenerateInviteScreen />} />
      <Route path="become-pro"      element={<BecomeProfessionalScreen />} />
      <Route path="settings"        element={<ProfileSettingsScreen />} />
      <Route path="doctor/:doctorId" element={<DoctorProfileScreen />} />
      <Route path="Booking"         element={<BookingScreen />} />
      <Route path="citas"           element={<MisCitasScreen />} />
      {/* Ruta por defecto del módulo consumidor */}
      <Route index element={<Navigate to="search" replace />} />
    </Routes>
  );
}

